import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const getItems = (root) => gsap.utils.toArray(root.querySelectorAll('[data-mosaic-drift-item]'));

const refreshAfterImagesLoad = (root) => {
    root.querySelectorAll('img').forEach((image) => {
        if (!image.complete) {
            image.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
        }
    });
};

Alpine.data('mosaicDrift', () => ({
    media: null,

    init() {
        const root = this.$root;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            root.classList.add('mosaic-drift--reduced-motion');
            return;
        }

        const stage = root.querySelector('.mosaic-drift__stage');
        const items = getItems(root);

        if (!stage || !items.length) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);
        refreshAfterImagesLoad(root);

        this.media = gsap.matchMedia();
        this.media.add(
            {
                isDesktop: '(min-width: 768px)',
                isMobile: '(max-width: 767px)',
            },
            (context) => {
                const { isMobile } = context.conditions;
                const desktopPositions = [
                    [-36, -18, 0.78, -8],
                    [-10, 8, 0.66, 4],
                    [28, -20, 0.74, 7],
                    [12, 24, 0.58, -5],
                    [-42, 28, 0.62, 6],
                    [40, 16, 0.7, -6],
                    [-4, -32, 0.68, 3],
                    [36, -2, 0.56, 8],
                    [-26, 0, 0.72, -4],
                ];
                const mobilePositions = [
                    [-62, -24, 0.62, -3],
                    [62, -16, 0.58, 2],
                    [-58, -4, 0.6, -2],
                    [58, 8, 0.56, 3],
                    [-64, 20, 0.58, -2],
                    [64, 30, 0.54, 2],
                    [-60, 38, 0.56, -1],
                    [60, 46, 0.52, 1],
                    [0, 56, 0.54, 0],
                ];
                const positions = isMobile ? mobilePositions : desktopPositions;
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: root,
                        start: 'top top',
                        end: () => `+=${Math.max(stage.offsetHeight, window.innerHeight) * (isMobile ? 3.5 : 4.4)}`,
                        pin: root.querySelector('.container'),
                        invalidateOnRefresh: true,
                        anticipatePin: 1,
                        scrub: true,
                        snap: false,
                    },
                });

                gsap.set(items, {
                    xPercent: -50,
                    yPercent: -50,
                    zIndex: (index) => index + 1,
                });

                items.forEach((item, index) => {
                    const position = positions[index % positions.length];

                    timeline.fromTo(
                        item,
                        {
                            x: `${position[0]}vw`,
                            y: `${position[1]}vh`,
                            scale: position[2],
                            rotate: position[3],
                            autoAlpha: index < 5 ? 1 : 0.76,
                        },
                        {
                            x: isMobile ? 0 : `${(index - Math.floor(items.length / 2)) * 4.5}vw`,
                            y: isMobile ? `${(index - Math.floor(items.length / 2)) * 7}vh` : 0,
                            scale: isMobile ? 0.55 : 0.48,
                            rotate: 0,
                            autoAlpha: 1,
                            ease: 'none',
                        },
                        0
                    );
                });

                return timeline;
            }
        );
    },

    destroy() {
        this.media?.revert();
    },
}));
